import { orderDetailsButtonSetStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderDetailsButtonSetStyles.buttonWrapper = mergeToNew(orderDetailsButtonSetStyles.buttonWrapper, {
    css: css`
        background: transparent;
    `,
});

orderDetailsButtonSetStyles.menuHidden = mergeToNew(orderDetailsButtonSetStyles.menuHidden, {
    css: css`
        button {
            background: transparent;

            &:focus {
                background: transparent;
            }
        }
    `,
});
